import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_STATUS',
    fieldMap: {
        id              : 'CIST_ID',
        name            : 'CIST_NAME',
        description     : 'CIST_DESCRIPTION',
        color           : 'CIST_COLOR',
        modifierUserId  : 'CIST_MODIFIER',
        modificationTime: 'CIST_MODIFICATION_TIME',
        uuid            : 'CIST_UUID'
    }
};

export default tableDefinition;
